import { useAnalytics, type TConvertEventsMap } from '@experience/frontend-analytics';
import { makeUseViewTracker, makeUseClickTracker } from '@experience/vue-analytics-directives';

import { getBootstrapData } from '@experience/core-hostapp-share-lib';
import { useRuntimeConfig } from 'virtual:runtime-config';

import type { EventsMap } from '@/shared/api/sogu';

const { VITE_RUNTIME_SOGU_SERVICE_URL } = useRuntimeConfig<false>();

const bootstrappedUserId = computed(() => getBootstrapData().user_id);
const referrer = computed(() => document.referrer);

const { trackEvent } = useAnalytics<TConvertEventsMap<EventsMap>>({
  soguURL: VITE_RUNTIME_SOGU_SERVICE_URL,
  appName: 'frontend-experience-app-listing',
  appVersion: __APP_VERSION__,
  userId: computed(() => bootstrappedUserId.value?.toString() || null),
  params: {
    referer: referrer.value,
  },
});

/**
 * Создает директиву Vue, реализующую отслеживание пересечений (intersections) для аналитики.
 *
 * @param eventName событие аналитики
 * @returns директива
 */
//TODO: убрать тс игнор, проверить соответствие типов библиотеки директив и библиотеки аналитики
//@ts-expect-error убрать тс игнор, проверить соответствие типов библиотеки директив и библиотеки аналитики
export const useViewTracker = makeUseViewTracker<EventsMap>(trackEvent);

/**
 * Создает директиву Vue, реализующую отслеживание кликов для аналитики.
 *
 * @param eventName событие аналитики
 * @returns директива
 */
//TODO: убрать тс игнор, проверить соответствие типов библиотеки директив и библиотеки аналитики
//@ts-expect-error убрать тс игнор, проверить соответствие типов библиотеки директив и библиотеки аналитики
export const useClickTracker = makeUseClickTracker<EventsMap>(trackEvent);

export { trackEvent };
